import { styled, css, Box } from '@mui/material'
import Button from '../Button'
import Grid from '../Grid'
import Heading from '../Heading'
import Icon from '../Icon'
import Price from '../Price'
import Text from '../Text'

export const CartListWrapper = styled(Grid)(() => css``)

export const CartListHeader = styled(Box)(
  () => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `
)

export const CartHeading = styled(Heading)(
  () => css`
    text-transform: uppercase;
  `
)
CartHeading.defaultProps = {
  size: 14
}

export const CartHeadingButtonWrapper = styled(Box)(
  () => css`
    margin-right: -6px;
  `
)

export const CartHeadingButton = styled(Button)(
  () => css`
    text-transform: none;
    text-decoration: underline;
    padding: 6px 8px;
    line-height: 1em;
  `
)
CartHeadingButton.defaultProps = {
  size: 'small',
  variant: 'text'
}

export const CartListGroupWrapper = styled(Grid)(() => css``)

export const CartListGroupHeader = styled('div')(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-top: 4px;
  `
)

export const CartListGroupHeaderSide = styled('div')(
  () => css`
    display: flex;
    align-items: flex-start;
    gap: 4px;
  `
)

export const CartListGroupIcon = styled(Icon)(
  () => css`
    display: block;
  `
)

export const CartListGroupHeading = styled(Heading)(
  () => css`
    &:first-letter {
      text-transform: capitalize;
    }
  `
)
CartListGroupHeading.defaultProps = {
  size: 14
}

export const CartListGroupTotal = styled(Price)(
  () => css`
    font-weight: bold;
  `
)
CartListGroupTotal.defaultProps = {
  size: 14,
  color: 'primary'
}

export const CartListGroupProducts = styled(Text)(() => css``)
CartListGroupProducts.defaultProps = {
  size: 12,
  variant: 'h2',
  color: 'primary'
}

export const SummarySubtotal = styled(Price)(() => css``)
